var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6185 1.65938C31.044 2.04235 32.1717 3.16999 32.5546 4.59548C33.2568 7.19117 33.278 12.574 33.278 12.574C33.278 12.574 33.278 17.9781 32.5759 20.5525C32.193 21.978 31.0653 23.1057 29.6398 23.4887C27.0654 24.1908 16.704 24.1908 16.704 24.1908C16.704 24.1908 6.3425 24.1908 3.7681 23.4887C2.34259 23.1057 1.21496 21.978 0.831994 20.5525C0.129883 17.9569 0.129883 12.574 0.129883 12.574C0.129883 12.574 0.129883 7.19117 0.810717 4.61677C1.19369 3.19126 2.32132 2.06363 3.74682 1.68067C6.32123 0.978546 16.6827 0.957275 16.6827 0.957275C16.6827 0.957275 27.0441 0.957275 29.6185 1.65938ZM21.9804 12.574L13.3849 17.5526V7.59542L21.9804 12.574Z",
    fill: "#002561"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeLogo);
export default __webpack_public_path__ + "static/media/YouTubeLogo.4ecc8b973928b2437dc65b196514cf75.svg";
export { ForwardRef as ReactComponent };